/**
 * Mobile config feature flags are usually stored as strings ("true" / "false").
 * Defaults to false when missing or unrecognized.
 */
export function isMobileConfigFlagEnabled(
  value: unknown,
  defaultWhenMissing = false,
): boolean {
  if (value == null || value === "") {
    return defaultWhenMissing;
  }

  if (typeof value === "boolean") {
    return value;
  }

  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (normalized === "true") {
      return true;
    }
    if (normalized === "false") {
      return false;
    }
  }

  if (typeof value === "number") {
    if (value === 1) {
      return true;
    }
    if (value === 0) {
      return false;
    }
  }

  return defaultWhenMissing;
}
